import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateTeacherPublicProfile, updateTeacherPublicProfile } from "./update-teacher-public-profile";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateTeacherPublicProfileReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateTeacherPublicProfile.fulfilled, state => {
    return { ...state, processing: "success" };
  });
  builder.addCase(updateTeacherPublicProfile.pending, state => {
    return { ...state, processing: "pending" };
  });
  builder.addCase(updateTeacherPublicProfile.rejected, state => {
    return { ...state, processing: "failed" };
  });
  builder.addCase(resetUpdateTeacherPublicProfile, () => {
    return initialState;
  });
});
